<template>
  <transition name="fade" mode="out-in">
    <router-view></router-view>
  </transition>
</template>

<script>
  export default {
    components: {},
    data () {
      return {}
    },
    mounted () {

    },
    methods: {}
  }
</script>

<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// src/views/home/homeMain.vue